import { MenuItem } from "@mui/material";

import { FILTER_TYPE_OPTIONS } from "../utils/constants";

export interface FilterTypeMenuItemsProps {
  skip?: (keyof typeof FILTER_TYPE_OPTIONS)[];
}

export const FilterTypeMenuItems = ({
  skip = [],
}: FilterTypeMenuItemsProps = {}) =>
  Object.entries(FILTER_TYPE_OPTIONS)
    .filter(([key]) => !skip.includes(key as keyof typeof FILTER_TYPE_OPTIONS))
    .map(([key, value]) => (
      <MenuItem key={key} value={key}>
        {value}
      </MenuItem>
    ));
